import script from "./ComponentWalk.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentWalk.vue?vue&type=script&setup=true&lang=js"

import "./ComponentWalk.vue?vue&type=style&index=0&id=e08bc702&lang=css"

const __exports__ = script;

export default __exports__